<template>
  <div class="message-templates">
    <EditMessageTemplateDialog
      :messageTemplate="selectedMessageTemplate"
      @close="closeDialog"
      :isOpen="isEditDialogOpen"
    />
    <div class="container col-lg-8 col-sm-12 mb-12">
      <BaseListToolbar title="Messages" @search="updateSearchValue" />
      <div v-if="isFetchingOrganisationMessageTemplates">
        <v-skeleton-loader v-for="i in 5" :key="i" s type="list-item-avatar" />
      </div>
      <div v-else>
        <v-list-item
          v-for="messageTemplate in messageTemplates"
          :key="messageTemplate.id"
          @click="handleSelect(messageTemplate)"
        >
          <MessageTemplateItem :messageTemplate="messageTemplate" />
        </v-list-item>
      </div>
      <v-pagination
        :total-visible="page.pageSize"
        v-if="showPagination"
        v-model="page.currentPage"
        @input="loadMessageTemplates"
        :length="page.lastPage"
      />
      <BaseFooter>
        <NewMessageTemplateAction />
      </BaseFooter>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_MESSAGE_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-message-templates";
import { FETCH_ORGANISATION_MESSAGE_TEMPLATES } from "@/store/modules/organisations/organisation-message-templates/actions";
import { copyState } from "@/utils/helpers";
import MessageTemplateItem from "@/views/settings/components/message-templates/components/MessageTemplateItem";
import BaseFooter from "@/components/common/BaseFooter";
import NewMessageTemplateAction from "@/views/settings/components/message-templates/components/actions/NewMessageTemplateAction";
import EditMessageTemplateDialog from "@/views/settings/components/message-templates/components/dialogs/EditMessageTemplateDialog";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { map, size } from "lodash";
import { getListedArray } from "@/utils/helpers";
import { paginationMixin } from "@/mixins/pagination.mixin";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_MESSAGE_TEMPLATES_NAMESPACE
);

export default {
  name: "MessageTemplates",
  mixins: [paginationMixin],
  components: {
    MessageTemplateItem,
    BaseFooter,
    NewMessageTemplateAction,
    EditMessageTemplateDialog,
    BaseListToolbar
  },
  created() {
    this.loadMessageTemplates();
  },
  data() {
    return {
      isEditDialogOpen: false,
      selectedMessageTemplate: {},
      searchText: ""
    };
  },
  computed: {
    ...mapState(
      copyState([
        "organisationMessageTemplates",
        "isFetchingOrganisationMessageTemplates"
      ])
    ),
    messageTemplates() {
      return map(this.organisationMessageTemplates, template => {
        const formattedTags = getListedArray(template.tags);
        return { ...template, formattedTags };
      });
    },
    requestParams() {
      return {
        filter: {
          ...(size(this.searchText) && { subject: this.searchText })
        },
        ...this.requestPageParams
      };
    }
  },
  methods: {
    ...mapActions({
      fetchMessageTemplates: FETCH_ORGANISATION_MESSAGE_TEMPLATES
    }),
    handleSelect(messageTemplate) {
      this.selectedMessageTemplate = messageTemplate;
      this.isEditDialogOpen = true;
    },
    async loadMessageTemplates() {
      const data = await this.fetchMessageTemplates(this.requestParams);
      if (data) {
        this.updatePageDetails(data.meta);
      }
    },
    closeDialog() {
      this.isEditDialogOpen = false;
    },
    updateSearchValue(text) {
      this.searchText = text;
      this.resetPagination();
      this.loadMessageTemplates();
    }
  }
};
</script>

<style lang="scss"></style>
